import { Icon } from "components/icon/Icon";
import { ExternalUser, ExternalUserRole } from "models/customers/customers";
import { useGlobalContext } from "app/store/GlobalContext";
import { useRootStore } from "store";

import "./ListExternalUsers.scss";

type Props = {
  onItemRemove: (id: string) => void;
  listItems: ExternalUser[];
};

export default function ListExternalUsers({ onItemRemove, listItems }: Props) {
  const { setEditingState } = useGlobalContext();

  const { changeRoleForCustomerUser } = useRootStore((state) => state.wizard);

  const handleRoleChange = (
    id: string,
    email: string,
    role: ExternalUserRole,
    checked: boolean
  ) => {
    setEditingState({ isEditing: true, location: "customer-settings" });

    changeRoleForCustomerUser(id, email, role, checked);
  };

  const handleRemove = (id: string) => {
    setEditingState({ isEditing: true, location: "customer-settings" });
    onItemRemove(id);
  };

  return (
    <div className="customerListWrapper">
      <ul className="customerList">
        <li key="-1">
          <div>Namn</div>
          <div id="authorized-signatory">Kundadmin</div>
          <div id="accounting-role">Redovisning</div>
          <div id="payroll-role">Lön</div>
          <div />
        </li>
        {listItems.map((item, index) => {
          const roles = item.roles || [];
          const isOwner = roles.includes(ExternalUserRole.Admin);
          const isAccounting = roles.includes(ExternalUserRole.Accounting);
          const isPayroll = roles.includes(ExternalUserRole.Payroll);

          return (
            <li key={item.email}>
              <div>
                {item.givenName} {item.surName} <span>{item.email}</span>
              </div>
              <div>
                <input
                  aria-labelledby="authorized-signatory"
                  onChange={(e) =>
                    handleRoleChange(
                      item.id,
                      item.email,
                      ExternalUserRole.Admin,
                      e.target.checked
                    )
                  }
                  type="checkbox"
                  checked={isOwner}
                />
              </div>
              <div>
                <input
                  aria-labelledby="accounting-role"
                  onChange={(e) =>
                    handleRoleChange(
                      item.id,
                      item.email,
                      ExternalUserRole.Accounting,
                      e.target.checked
                    )
                  }
                  type="checkbox"
                  checked={isAccounting}
                  disabled={isOwner}
                />
              </div>
              <div>
                <input
                  aria-labelledby="payroll-role"
                  onChange={(e) =>
                    handleRoleChange(
                      item.id,
                      item.email,
                      ExternalUserRole.Payroll,
                      e.target.checked
                    )
                  }
                  type="checkbox"
                  checked={isPayroll}
                  disabled={isOwner}
                />
              </div>
              <div>
                <Icon
                  id={item.id}
                  onClick={() => handleRemove(item.id)}
                  name="trash-o"
                  className="trashCan"
                  size="lg"
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
